import { action, runInAction, observable } from 'mobx';
import { ErrorInterface } from 'modules/core/api/globalApi';
import schedulerController from './controller';
import {
  SchedulerUndeterminedItemInterface,
  SetStatusNoticeRequest,
} from '../api/schedulerStatusNoticeApi';

export interface SchedulerStatusNoticeStore {
  schedulerUndetermined: SchedulerUndeterminedItemInterface[],
  loading: boolean,
  error: ErrorInterface,
}

const initialValues: SchedulerStatusNoticeStore = {
  schedulerUndetermined: [],
  loading: false,
  error: null,
};
export const schedulerStatusNoticeStore = observable(initialValues);

export const schedulerStatusNoticeActions = {

  getSchedulerUndetermined: action(async () => {
    schedulerStatusNoticeActions.clearError();
    schedulerStatusNoticeStore.loading = true;
    const response = await schedulerController.getSchedulerUndetermined();
    schedulerStatusNoticeActions.handleError(response);
    runInAction(() => {
      schedulerStatusNoticeStore.schedulerUndetermined = response?.data?.items ?? [];
      schedulerStatusNoticeStore.loading = false;
    });
  }),

  updateStatusNotice: async (request: SetStatusNoticeRequest): Promise<string> => {
    schedulerStatusNoticeActions.clearError();
    const response = await schedulerController.updateStatusNotice(request);
    if (response.errorData) { 
      schedulerStatusNoticeActions.handleError(response);
      return 'fail';
    }
    else {
      return 'success';
    }
  },

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      schedulerStatusNoticeStore.error = errorData;
      schedulerStatusNoticeStore.loading = false;
      throw errorData;
    }
  }),

  clearError() {
    try {
      runInAction(() => {
        schedulerStatusNoticeStore.error = null;
        schedulerStatusNoticeStore.loading = false;
      });
    } catch (err) {
      this.handleError(err);
    }
  },

  clearSchedulerUndetermined: action(() => {
    schedulerStatusNoticeStore.schedulerUndetermined = [];
  }),

};
